<template>
  <v-card>
    <v-card-title>Suche Mitarbeiter*in</v-card-title>
    <v-card-text>
      <div class="text-left pb-3">nach <strong>MitarbeiterInnen</strong> oder <strong>VBZ Nr.</strong> suchen</div>
      <v-text-field v-model="search" :label="label" autofocus clearable class="width-100"></v-text-field>

      <div class="d-flex full-width">
        <div class="d-flex flex-grow-1 flex-column scroll-container" style="height: 300px">
          <div v-for="item in filteredUsers" :key="item.id" @click="select(item)" class="mb-2 item-container" v-ripple>
            <div class="text-subtitle-1">{{ item.firstname }} {{ item.lastname }}</div>
            <div class="caption">VBZ Nr. {{ item.companynr }}</div>
          </div>
        </div>
      </div> </v-card-text
    ><v-card-actions class="align-end justify-end">
      <v-btn @click="$emit('cancel')">abbrechen</v-btn>
      <v-btn color="primary" @click="save">übernehmen</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapState } from 'vuex';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';

export default {
  name: 'PersonAutocomplete',
  mixins: [wsMixin],
  props: {
    vbzNrString: String,
    label: { type: String, default: 'MitarbeiterInnen Suche' },
  },

  data() {
    return {
      isLoading: false,
      model: isNaN(Number(this.vbzNrString)) ? null : Number(this.vbzNrString),
      search: '',
    };
  },
  computed: {
    ...mapState('vbzWorksheet', ['users', 'userByCompanyNr']),
    sortedUsers() {
      return this.users
        .filter((u) => u.companynr)
        .slice()
        .sort(this.mx_formatUserSorter)
        .filter((u) => u.firstname || u.lastname);
    },
    filteredUsers() {
      if (!this.search) return this.sortedUsers;
      let searchParts = this.search.toLowerCase().split(' ');
      return this.sortedUsers.filter((user) => {
        let lowerCasedUser = `${user.companynr} ${user.firstname}} ${user.lastname}`.toLowerCase();
        if (!user.firstname && !user.lastname) return false;
        return searchParts.every((sp) => lowerCasedUser.includes(sp));
      });
    },
  },
  methods: {
    select(user) {
      this.model = user;
      this.search = this.mx_formatUser(user);
    },
    save() {
      this.$emit('save', this.model ? `${this.model.companynr}` : null);
    },
  },
  watch: {
    vbzNrString(newValue, oldValue) {
      console.debug(`vbzNrString changed to ${newValue} isNaN(newValue)=${isNaN(newValue)}`);
      this.model = isNaN(newValue) ? null : Number(newValue);
      this.search = '';
    },
  },
};
</script>

<style scoped>
.item-container {
  padding: 0 0.5em;
}
.item-container {
  cursor: pointer;
}
.theme--light .item-container:hover {
  background-color: rgba(211, 211, 211, 0.5);
}
.theme--dark .item-container:hover {
  background-color: rgba(23, 21, 21, 0.5);
}
</style>
